var map = {
	"./1.png": "e1V8",
	"./10.png": "a1Pa",
	"./11.png": "Vz/W",
	"./2.png": "b3g0",
	"./3.png": "V6JR",
	"./4.png": "1iMo",
	"./5.png": "v78M",
	"./6.png": "zrrt",
	"./7.png": "vbID",
	"./8.png": "wK8k",
	"./9.png": "oqGq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bRzj";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxopen ^\.\/.*\.png$
// module id = bRzj
// module chunks = 1